import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// JS Files
import Navbar from "../../../shares/Navbar";
import Footer from "../../../shares/Footer";
import { useAuth } from "../../../../context/AuthContext";
import MuiUpload from "../../../shares/MuiUpload";
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import MuiModal from "../../../shares/MuiModal";

// Others File
import sampleImg from "../../../../imgs/app.svg";
import Waiting from "../Waiting";

const typeList = [
  {
    name: "کارت ملی - رو",
    value: "ro_cart_meli",
  },

  {
    name: "کارت ملی - پشت",
    value: "posht_cart_meli",
  },
  {
    name: "شناسنامه - صفحه اول",
    value: "shenasname_1",
  },
  {
    name: "شناسنامه - صفحه دوم",
    value: "shenasname_2",
  },
  {
    name: "شناسنامه - صفحه سوم",
    value: "shenasname_3",
  },
];

const StepTwo = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const [postData, setPostData] = useState();
  const [selectedType, setSelectedType] = useState("");
  const [selectedFile, setSelectedFile] = useState();

  const { userData } = useUserData();
  const [data, setData] = useState([]);
  const GetMainInsuredFiles = useFetch({
    url: `User_Service/${userData.username}/user_get_treatment_request_info`,
    method: "GET",
    trigger: true,
    argFunc: (res) => {
      setData(res.data.treatment_request_main_insured[0].main_insured_files);
    },
    errMessage: (res) => {},
  });

  const [isUploading, setIsUploading] = useState(false);
  const AddFileMainInsured = useFetch({
    url: `TreatmentMainInsuredFile_Service`,
    method: "POST",
    data: postData,
    trigger: false,
    argFunc: (res) => {
      setSelectedFile();
      setSelectedType("");
      GetMainInsuredFiles.reFetch();
      setIsUploading(false);
    },
    errMessage: (res) => {},
  });
  const addFile = (f, value) => {
    setIsUploading(true);
    setSelectedFile(f);

    let formData = new FormData();

    formData.append("attach_file", f, f.name);
    formData.append("file_type", value);
    formData.append(
      "treatment_main_insured",
      location.state.treatmentRequestMainInsuredId
    );
    setPostData(formData);
    AddFileMainInsured.reFetch();
  };
  return (
    <>
      {isUploading && (
        <MuiModal
          openModal={isUploading}
          setOpenModal={setIsUploading}
          width="w-1/3"
          isNotBackdropClick
        >
          <Waiting text="تصویر در حال اپلود است، لطفا صبر کنید." />
        </MuiModal>
      )}
      <div className="hp-section-one">
        <Navbar activePage="aboutus" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">ثبت‌نام بیمه درمان تکمیلی</p>
        <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4">
          <div className="border-r-4 border-mygray-300 px-4">
            <span className="text-sm md:text-base font-bold text-mygray-700">
              بارگذاری مدارک بیمه‌شده اصلی
            </span>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-8">
            {typeList.map((item, index) => {
              return (
                <div className="border border-dashed rounded-lg">
                  <span className="bg-gray-100 p-2 w-full text-center text-gray-500 text-sm rounded-t-lg block">
                    {item.name}
                  </span>
                  {data.length > 0 && (
                    <div className="flex justify-center">
                      <img
                        className="h-32"
                        src={
                          data.filter((it) => it.file_type == item.value)
                            .length > 0 &&
                          data.filter((it) => it.file_type == item.value)[0]
                            .attach_file
                        }
                      />
                    </div>
                  )}
                  <MuiUpload
                    setImageFile={(f) => addFile(f, item.value)}
                    accept="image/*"
                    id={item.value}
                    disabled={AddFileMainInsured.loading}
                  />
                </div>
              );
            })}
          </div>
          {/* <div className="grid md:grid-cols-4 gap-8 md:gap-16 md:mt-8 mx-4 md:mx-12 mt-4">
            <MuiSelect
              size="small"
              inputLabel="انتخاب مدرک"
              labelId="evidence-label"
              id="evidence-select"
              label="evidence"
              menuItems={typeList}
              onChange={(e) => {
                setSelectedType(e.target.value);
              }}
              value={selectedType}
            />
            <MuiUpload
              disabled={selectedType == ""}
              setImageFile={addFile}
              accept="image/*"
            />
          </div> */}
          {/* <div className="md:mt-8 mx-4 md:mx-12">
            <p className="font-bold text-mygray-700 text-sm md:text-base mt-4">
              تصاویر آپلود شده:
            </p>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-6">
              {data.map((it, ind) => {
                return [
                  <div className="border border-dashed rounded-lg flex flex-col items-center justify-center">
                    <img
                      className="w-full h-full rounded-t-lg"
                      src={it.attach_file}
                    />
                    <span className="bg-gray-100 p-2 w-full text-center text-gray-500 text-sm rounded-b-lg">
                      {it.fa_file_type}
                    </span>
                  </div>,
                ];
              })}
            </div>
          </div> */}
        </div>
        <div className="text-left mt-8 flex justify-between items-center">
          <MuiButton
            onClick={() => navigate(-1)}
            type="submit"
            variant="outlined"
            color="primary"
            text="بازگشت"
          />
          <MuiButton
            onClick={() =>
              navigate("/step-three", {
                state: {
                  treatmentRequestMainInsuredId:
                    location.state.treatmentRequestMainInsuredId,
                  treatmentRequestId: location.state.treatmentRequestId,
                },
              })
            }
            type="submit"
            variant="contained"
            color="primary"
            text="تایید و ادامه"
            disabled={data.length < 5}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};
export default StepTwo;
